export class TiendaEntity {

  id?: number;

  idDB?: string;

  nombre?: string;

  categoria?: string;
  locacion?: string;
  negocio?: string;
  activo?:number;
  horario?:string|any;

}
